module.exports = __webpack_public_path__ + "img/xlh1.6fd8a61a.jpg";